module.exports = __webpack_public_path__ + "tick.png";


//////////////////
// WEBPACK FOOTER
// ./ui/src/vendor/calendar/img/tick.png?2
// module id = 791
// module chunks = 1